<template>
  <div class="error-container">
    <div class="error-content">
      <div class="logo">
        <img src="/img/logo_small.svg" alt="Leon Hotel Logo" />
      </div>
      <h1 class="error-title">{{ error?.statusCode === 404 ? t('error.not_found') : t('error.something_wrong') }}</h1>
      <p class="error-message">{{ error?.message || t('error.try_again') }}</p>
      <div class="error-actions">
        <button class="back-button" @click="handleError">
          {{ t('error.go_home') }}
        </button>
      </div>
    </div>
    <div class="borders b-d-left b-d-right b-d-top b-d-bottom"></div>
  </div>
</template>

<i18n lang="json">
{
  "en": {
    "error": {
      "not_found": "Page not found",
      "something_wrong": "Something went wrong",
      "try_again": "Try again",
      "go_home": "Go to home"
    }
  },
  "ru": {
    "error": {
      "not_found": "Страница не найдена",
      "something_wrong": "Что-то пошло не так",
      "try_again": "Попробуйте еще раз",
      "go_home": "Вернуться на главную"
    }
  }
}
</i18n>

<script setup lang="ts">
const props = defineProps({
  error: {
    type: Object as PropType<{
      statusCode: number
      message?: string
    }>,
    required: true
  }
})

const { t } = useI18n()
const router = useRouter()

const handleError = () => {
  if (props.error?.statusCode === 404) {
    router.push('/')
  } else {
    router.go(-1)
  }
}
</script>

<style lang="scss" scoped>
.error-container {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  background-color: #fff;
  position: relative;
}

.error-content {
  text-align: center;
  max-width: 600px;
  width: 100%;
  padding: 4rem 2rem;
  position: relative;
  z-index: 2;
}

.logo {
  margin-bottom: 3rem;

  img {
    height: 69px;
    filter: invert(1);
  }
}

.error-title {
  font-family: "Lato", sans-serif;
  font-size: 2.5rem;
  color: #000;
  margin-bottom: 1.5rem;
  font-weight: 400;
}

.error-message {
  font-family: "Lato", sans-serif;
  font-size: 1.125rem;
  color: #666;
  margin-bottom: 2.5rem;
  line-height: 1.6;
}

.error-actions {
  .back-button {
    background-color: #d9ccaf;
    color: #000;
    border: none;
    padding: 1rem 2.5rem;
    font-family: "Lato", sans-serif;
    font-size: 1rem;
    cursor: pointer;
    transition: opacity 0.3s ease;

    &:hover {
      opacity: 0.9;
    }
  }
}

.borders {
  position: absolute;
  left: 55px;
  right: 55px;
  top: 55px;
  bottom: 55px;
  z-index: 1;
}

@media screen and (max-width: 768px) {
  .error-container {
    padding: 1rem;
  }

  .error-content {
    padding: 2rem 1rem;
  }

  .error-title {
    font-size: 2rem;
  }

  .error-message {
    font-size: 1rem;
  }

  .borders {
    left: 20px;
    right: 20px;
    top: 20px;
    bottom: 20px;
  }
}
</style>
